import { Dispatch, RefObject, SetStateAction } from 'react';
import MyModal from '../../../../../components/Modal';
import { MappedVehicleType } from '../../types';
import QRCode from 'react-qr-code';
import { VehicleInfoContainer } from './styles';

interface QrCodeModalInterface {
  vehicleQrCodeModalShow: boolean;
  companyName: string;
  setVehicleQrCodeModalShow: Dispatch<SetStateAction<boolean>>;
  downloadQrCode: () => void;
  exportRef: RefObject<HTMLDivElement>;
  isDownloadingQrCode: boolean;
  vehicleQrCodeBeingShow: MappedVehicleType;
}

export default function QrCodeModal({
  vehicleQrCodeModalShow,
  companyName,
  setVehicleQrCodeModalShow,
  downloadQrCode,
  exportRef,
  isDownloadingQrCode,
  vehicleQrCodeBeingShow,
}: QrCodeModalInterface) {
  return (
    <MyModal
      show={vehicleQrCodeModalShow}
      title={`QR Code veículo ${vehicleQrCodeBeingShow.vehicleCode}`}
      isActionButtonDisabled={isDownloadingQrCode}
      modalBody={(
        <div key={vehicleQrCodeBeingShow.vehicleId} ref={exportRef}>
          <VehicleInfoContainer>
            <h1>{vehicleQrCodeBeingShow.vehicleCode}</h1>
            <h1>{companyName}</h1>
            <h1>
                        Qr Code:
              {' '}
              {vehicleQrCodeBeingShow.qrCode}
            </h1>
          </VehicleInfoContainer>
          <QRCode
            value={`${vehicleQrCodeBeingShow.qrCode}`}
            size={50}
            style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
            viewBox="0 0 50 50"
          />
        </div>
      )}
      closeButtonLabel="Fechar"
      onClose={() => setVehicleQrCodeModalShow(false)}
      actionButtonLabel="Download"
      onAction={() => downloadQrCode()}
      type="action"
      size="lg"
      centeredBody
    />
  );
}
